'use client';

import { useState } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { useResolvedColorScheme } from '@/hooks/useResolvedColorScheme';
import {
  EBV_LEFT_DIRECTION_COLUMN_WIDTH_PX,
  EBV_RIGHT_DIRECTION_COLUMN_WIDTH_PX,
  EBV_TRAIT_NAME_COLUMN_WIDTH_PX,
  PERCENTILE_SCALE_10,
  PERCENTILE_SCALE_20,
} from './ebvPercentileUtils';
import { useEbvTraitExplanationPopover } from './useEbvTraitExplanationPopover';

export function useEbvChartLayout() {
  const theme = useTheme();
  const { isDarkMode } = useResolvedColorScheme();
  const useCompactTraitLabels = useMediaQuery(theme.breakpoints.down('md'));
  const percentileScale = useCompactTraitLabels
    ? PERCENTILE_SCALE_20
    : PERCENTILE_SCALE_10;
  const traitColumnWidth = useCompactTraitLabels
    ? EBV_TRAIT_NAME_COLUMN_WIDTH_PX
    : 200;
  const leftDirectionColumnWidth = useCompactTraitLabels
    ? EBV_LEFT_DIRECTION_COLUMN_WIDTH_PX
    : 70;
  const rightDirectionColumnWidth = EBV_RIGHT_DIRECTION_COLUMN_WIDTH_PX;

  const [graphInfoOpen, setGraphInfoOpen] = useState(false);
  const {
    popoverAnchor,
    popoverEntry,
    openPopover,
    handleInfoClick,
    handlePopoverClose,
  } = useEbvTraitExplanationPopover();

  return {
    theme,
    isDarkMode,
    useCompactTraitLabels,
    percentileScale,
    traitColumnWidth,
    leftDirectionColumnWidth,
    rightDirectionColumnWidth,
    graphInfoOpen,
    setGraphInfoOpen,
    popoverAnchor,
    openPopover,
    popoverEntry,
    handleInfoClick,
    handlePopoverClose,
  };
}
